// config.cavallbernat.js
  /*
   ESO BATXILLERAT I CICLES (Mariona Sanchez i Alba)

    authLlibresSocialitzats
    authPagament
  
    "authCompromis": authCompromis,
    "authDretsImatge": authDretsImatge,
    "authSortides": authSortides,
    "authAMPA": authAMPA,
    "authMedica": authMedica,
    "authResponsable": authResponsable,
    "authMobils": authMobils,
    "authGDPR": authGDPR,
    "authPagament": authPagament
    if( authLlibresSocialitzatsCriteria) d.authLlibresSocialitzats = authLlibresSocialitzats
    if( authAlcoholCriteria ) d.authAlcohol = authAlcohol
    if( authMedicaCriteria ) d.authMedica = authMedica

  */

const textInscripcioText = () =>  {

  return (<>CONSULTEU LA <a href="http://www.inscavallbernat.cat/" target="_blank" rel="noreferrer">PÀGINA WEB DE L'INSTITUT CAVALL BERNAT</a> PER INFORMAR-VOS DEL MATERIAL I ELS LLIBRES QUE NECESSITEU PER INICIAR EL CURS</>)

}

const config =
{
    cid: 'a8053251',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/cavallbernat/)
    autoritzacions: [
        'authAlcohol', 'authAMPA', 'authCompromis', 'authDretsImatge', 'authGDPR',
        'authLlibresSocialitzats', 'authMedica', 'authMobils', 'authPagament',
        'authPortatils', 'authResponsable', 'authSortides',
    ],

    phone: "93 785 11 43",
    email: "a8053251@xtec.cat",

    headerLogo:  'img/logo_bn_cavallbernat.png',
    headerTitle:  'Institut Cavall Bernat',
    headerURL: 'https://matricula.inscavallbernat.cat/',

    //enrollmentPostURL: 'https://matricula.inscavallbernat.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.inscavallbernat.cat/api/',
    apiURL: '/api/',

    popupInicial: true,

    /* valor per defecte (mandatori); es pot sobreescriure per curs concret amb
       curs.adjuntarArxiusNoObligatori a les dades de families (chkiddoc + cursObligatori);
       aquest valor només s'aplica a la matrícula lliure, sense curs obligatori */
    adjuntarArxiusNoObligatori: false,

    // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
    llibreFamiliaObligatori: false,

    validaIDdocuments: true,
    tipusDocTSI: true,

    fotoCarnet: true,
    validaIAfotoCarnetFile: true,
    validaIAiddocumentFrontFile: false,

    telefonObligatori: true,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    notesAcces: false,

    mostraTorns: false,

   demanaConvalidacions: true,
   demanaConvalidacionsText: "Si vols convalidar algun dels MP dels quals t'has matriculat, omple <a href='/docs/sollicitud_convalidacio_v1.doc' target='_blank'>aquest formulari</a> i adjunta'l aquí amb la documentació sol·licitada. Igualment, podràs fer-ho a principis de curs si ho prefereixes",
   demanaConvalidacionsFile: true,

    logo: 'img/logo_cavallbernat.jpg',
    titol: 'INS Cavall Bernat',

    favicon: '/img/favicon-cavallbernat.ico',
    faviconGestio: '/gestio/img/favicon-cavallbernat.ico',

    assignatures: 'assignatures/assignatures.cavallbernat.json',
    families: 'families/families.cavallbernat.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.cavallbernat.json',
    calculquota: 'quotes.cavallbernat.json',

    /* camps especifics per centre */
    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "",

    textBotoMatricular: "INSCRIURE",

    proporcionarPreinscripcioNous: true,
    proporcionarTitolPreinscripcioNous: true,

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: null,

    urlTPV: "https://matricula.inscavallbernat.cat/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    textInscripcioText: null,

    dosTerminisDefault: true, // per defecte el dos terminis està activat
    dosTerminisAmagaBoto: true, // no cal ni mostrar botó

    textTerminis: [ "(amb la matrícula)", "(del 14 al 30 de setembre)", null ], // els que tenen tres terminis ja especifiquem expressament


    // diu dos però també serveix pels 3 terminis
    /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
    dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),
    /* si es fals mostrem unes altres condicions de pagament */
    dosTerminisEnabledFalseCondicio: 0,



    sexeNoBinari: true,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;